export default __webpack_public_path__ + "static/media/altromPrivilegeLogo.2b4bd760.svg";